export const SET_IN_SERVICE_AREA = "SET_IN_SERVICE_AREA";
export const SET_ZIP_CODE = "SET_ZIP_CODE";
export const SET_LOCALE = "SET_LOCALE";
